import Metadata from './metadata';
export default function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/libphonenumber-js/es6/getCountries.js
// module id = 1713
// module chunks = 6 14 79